import { trackEvent } from './utils.js';


export function addNewsletterForm(element) {

    if(!element) {
      return
    }

    const form = element.querySelector('form')
    const thanks = element.querySelector('.thank-you-copy')

    form.addEventListener('submit', (e)=> {
      e.preventDefault()
      const signUp = document.getElementsByName('newsletter-sign-up')[0].value
      post(signUp)
    })

    const post = (data) => {
      const postAddress = window.root + '/tools/mailingList?method=sign-up&locale=' + CCM_ACTIVE_LOCALE + '&date=' + new Date().getTime()
      const xhr = new XMLHttpRequest()

      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          respond(xhr)
        }
      }

      xhr.open('POST', postAddress)
      xhr.send(data)
    }

    const respond = (response) => {

      if(response.responseText.includes('OK')) {
        thanks.classList.add('show')
        form.classList.remove('show')
        trackEvent({ type: 'newsletter', ev: 'sign-up', val: 'success' })
      } else {
        trackEvent({ type: 'newsletter', ev: 'sign-up', val: 'fail' })
      }

    }

}


// WEBPACK FOOTER //
// ./src/newsletter.js